/**
 * @copyright © Paramount Streaming
 * @author Stan Gletski
 * @description Adapted error codes from player
 * @see {@link https://avia.cbsivideo.com/avia-js/latest/docs/api/player/enum/ErrorCode}
 */
export enum PlayerAdapterErrorCode {
	// Resource errors (match ErrorCodeMap 1000s)
	INVALID_RESOURCE_FORMAT = '1000',
	RESOURCE_UNAVAILABLE = '1100',
	GEOBLOCKED = '1101',
	PROVIDER_BLOCKED = '1102',
	GEOBLOCK_SOFT_FAILED = '1103',
	SATELLITE_PROVIDER_BLOCKED = '1104',
	EXPIRED = '1105',
	SELECTOR_CALL_ERROR = '1106',
	IMA_SDK_MISSING = '1200',
	DAI_SDK_MISSING = '1201',
	DASH_SDK_MISSING = '1202',
	HLSJS_SDK_MISSING = '1203',
	SHAKA_SDK_MISSING = '1204',

	// Video start errors (match ErrorCodeMap 2000s)
	DYNAMIC_VARIANT_MANIFEST_PARSE_ERROR = '2000',
	HLSJS_PARSE_ERROR = '2100',
	DASHJS_PARSE_ERROR = '2200',
	USER_GESTURE_REQUIRED = '2300',

	// Network errors (custom 1000s range)
	NETWORK_ERROR = '1010',
	NETWORK_TIMEOUT = '1011',

	// Media errors (custom 2000s range)
	DECODE_ERROR = '2000',
	SRC_NOT_SUPPORTED = '2001',
	MEDIA_ELEMENT_ERROR = '2002',

	// OIPF errors (Smart TV platforms - custom 2100s)
	OIPF_SRC_NOT_SUPPORTED = '2100',
	OIPF_DECODE_ERROR = '2101',
	OIPF_NETWORK_ERROR = '2102',

	// Playback errors (match ErrorCodeMap 3000s)
	HTML5_NETWORK_ERROR = '3001',
	HLSJS_NETWORK_ERROR = '3002',
	DASHJS_NETWORK_ERROR = '3003',
	WEBMAF_NETWORK_ERROR = '3004',
	SHAKA_NETWORK_ERROR = '3005',
	MEDIA_ABORTED = '3100',
	HTML5_SRC_NOT_SUPPORTED = '3101',
	HLSJS_SRC_NOT_SUPPORTED = '3102',
	DASHJS_SRC_NOT_SUPPORTED = '3103',
	WEBMAF_SRC_NOT_SUPPORTED = '3104',
	HTML5_MEDIA_ERROR = '3200',
	HLSJS_MEDIA_ERROR = '3201',
	HLSJS_MUX_ERROR = '3202',
	DASHJS_MEDIA_ERROR = '3203',
	WEBMAF_MEDIA_ERROR = '3204',

	// DRM errors (match ErrorCodeMap 3300s)
	FAIRPLAY_APP_CERT_ERROR = '3300',
	FAIRPLAY_LIC_ERROR = '3301',
	DASHJS_DRM_ERROR = '3302',
	WEBMAF_DRM_ERROR = '3303',
	PLAYREADY_DRM_ERROR = '3304',

	// Unspecified errors (match ErrorCodeMap 3400s)
	UNSPECIFIED_VIDEO_PLAYBACK_ERROR = '3400',
	UNSPECIFIED_HLSJS_ERROR = '3401',
	UNSPECIFIED_DASHJS_ERROR = '3402',
	UNSPECIFIED_PS4_ERROR = '3403',

	// Ad errors (match ErrorCodeMap 4000s)
	AD_STALLED = '4000',
	IMA_INIT_FAILURE = '4100',
	IMA_AD_ERROR = '4101',
	DAI_DATA_ERROR = '4200',
	DAI_NETWORK_ERROR = '4201',
	DAI_SDK_MISSING_ERROR = '4202',
	AD_BLOCKING_DETECTED = '4300',

	// Plugin errors (common avia-js pattern)
	PLUGIN_ERROR = '7000',
	PLUGIN_LOAD_ERROR = '7001',
	PLUGIN_INIT_ERROR = '7002',
	PLUGIN_CONFIG_ERROR = '7003',

	// EME/DRM advanced errors (potential avia-js codes)
	EME_NOT_SUPPORTED = '6000',
	EME_KEY_SESSION_ERROR = '6001',
	EME_CERTIFICATE_ERROR = '6002',
	EME_LICENSE_REQUEST_ERROR = '6003',

	// Audio errors (potential avia-js codes)
	AUDIO_DECODE_ERROR = '5000',
	AUDIO_NOT_SUPPORTED = '5001',
	AUDIO_CONTEXT_ERROR = '5002',

	// Unexpected condition (match ErrorCodeMap)
	UNEXPECTED_CONDITION = '9999',

	// Generic errors (custom 9000s range)
	UNKNOWN_ERROR = '9000',
	PLAYER_ERROR = '9001'
}